import React, { useState, useEffect } from 'react';
import noUiSlider from 'nouislider';
import { formatNumberWithComma, formatNumberToDollar } from '../../../_fyh/src/util/formatNumber';
/**
 * This will copy the functionality in _fyh/src/components/shared/slider.js
 * - since the dependency versions differ between FYH and Viewport Map, we
 *   are unable to reuse the functionality directly, but once the apps
 *   get consolidated, we will be able to have a single Slider component
 */
const Slider = ({ title, minValue, maxValue, sliderBounds, minInputLabel, maxInputLabel, step, currency = false, onSliderChange, maxPricePlus = false, className }) => {
    const [leftHandle, setLeftHandle] = useState(sliderBounds.selectedMin);
    const [rightHandle, setRightHandle] = useState(sliderBounds.selectedMax);
    const idPrefix = title.toLowerCase().replace(' ', '-');
    // update hook for the noUiSlider component
    useEffect(() => {
        setLeftHandle(sliderBounds.selectedMin);
        setRightHandle(sliderBounds.selectedMax);
        const slider = document.getElementById(idPrefix);
        if (slider.noUiSlider) {
            slider.noUiSlider.updateOptions({
                start: [sliderBounds.selectedMin, sliderBounds.selectedMax],
            });
        }
        else {
            noUiSlider.create(slider, {
                range: {
                    min: minValue,
                    max: maxValue
                },
                start: [sliderBounds.selectedMin, sliderBounds.selectedMax],
                handleAttributes: [{ 'aria-label': minInputLabel }, { 'aria-label': maxInputLabel }],
                step: step,
                connect: [false, true, false]
            });
            slider.noUiSlider.on('change', handleSliderChange);
        }
    }, [sliderBounds]);
    const handleSliderChange = (value) => {
        console.log('handle slider change value', value);
        onSliderChange({
            selectedMin: parseInt(value[0]),
            selectedMax: parseInt(value[1])
        });
        setLeftHandle(parseInt(value[0]));
        setRightHandle(parseInt(value[1]));
    };
    return (React.createElement("div", { className: 'range-slider' + (className ? ' ' + className : '') },
        React.createElement("h3", { className: "filter-title" }, title),
        React.createElement("div", { id: idPrefix }),
        React.createElement("div", { className: "range-input-container" },
            React.createElement("div", { className: "range-input" },
                React.createElement("label", { htmlFor: idPrefix + '-leftHandleInput' }, minInputLabel),
                React.createElement("input", { name: "leftHandle", id: idPrefix + '-leftHandleInput', readOnly: true, value: currency ? formatNumberToDollar(leftHandle) : formatNumberWithComma(leftHandle) })),
            React.createElement("span", null, "-"),
            React.createElement("div", { className: maxPricePlus ? 'range-input plus' : 'range-input' },
                React.createElement("label", { htmlFor: idPrefix + '-rightHandleInput' }, maxInputLabel),
                React.createElement("input", { name: "rightHandle", id: idPrefix + '-rightHandleInput', value: currency ? formatNumberToDollar(rightHandle) : formatNumberWithComma(rightHandle), readOnly: true })))));
};
export default Slider;
